<script>
import Layout from "../../layouts/auth";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";

import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
import AccountService from "@/services/others/account.service";
import Captcha from "./recaptcha.vue";

/**
 * Login component
 */
export default {
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Captcha,
  },
  data() {
    return {
      username: "",
      password: "",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      LoginLoading: false,
      Loading: false,
      SignTwoFactorLoading: false,
      login: {
        username: "",
        password: "",
        captchatext: "",
      },
      sms: {
        trusteddevice: false,
        phoneNumber: "",
      },
      showCaptcha: false,
      userData: {},
      userInfo: {},
      result: "",
      RequiredCaptcha: false,
      validations: {
        username: {
          required,
        },
        password: {
          required,
        },
      },
    };
  },
  computed: {
    ...mapState("authfack", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
    isLocal() {
      return false;
    },
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    SignIn() {
      this.Loading = true;
      AccountService.SignIn(this.login)
        .then((res) => {
          this.Loading = false;
          if (res.data.RequiredCaptcha && !res.data.success) {
            this.GenerateCaptcha();
          }
          if (res.data.success) {
            this.userData = res.data.userinfo;
            this.userInfo = res.data;
            this.completeLogin();
          } else {
            this.$notification(res.data.message || "Login failed", "danger");
          }
        })
        .catch((error) => {
          this.Loading = false;
          if (
            error.response &&
            error.response.data &&
            error.response.data.RequiredCaptcha
          ) {
            this.GenerateCaptcha();
          }

          this.$notification(error.response.data.error, "danger");
        });
    },
    GenerateCaptcha() {
      AccountService.GenerateCaptcha(this.login)
        .then((res) => {
          if (res.data.success) {
            this.result = res.data.result;
            this.showCaptcha = true;
          }
        })
        .catch((error) => {
          this.$notification(error.response.data.error, "danger");
        });
    },
    SignTwoFactor() {
      if (!this.sms.smscode) {
        this.$notification(this.$t("SmsCodeNotCorrect"), "danger");
        return false;
      }
      this.SignTwoFactorLoading = true;
      AccountService.SignInTwoFactor(this.sms)
        .then((res) => {
          this.SignTwoFactorLoading = false;
          if (res.data.userinfo) {
            this.completeLogin(res.data);
          }
        })
        .catch((error) => {
          this.$notification(error.response.data.error, "danger");
          this.SignTwoFactorLoading = false;
        });
    },
    tryToLogIn() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.LoginLoading = true;
      AccountService.GenerateToken({
        username: this.username,
        password: this.password,
      })
        .then((res) => {
          if (res.data.success) {
            this.$store.commit("loginSuccess", res.data);
            if (res.data.token) {
              this.completeLogin(res.data);
            }
          } else {
            this.LoginLoading = false;
            this.$notification(res.data.message || "Login failed", "error");
          }
        })
        .catch((error) => {
          this.LoginLoading = false;
          this.$notification(error.response.data.error, "error");
        });
    },

    completeLogin() {
      localStorage.setItem("user_info", JSON.stringify(this.userData));
      this.$store.commit("loginSuccess", this.userInfo);
      this.showCaptcha = false;

      this.$router.push("/");
    },
  },
};
</script>
<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-12">
                <div class="text-primary p-4 pb-0">
                  <h5 class="text-center text-primary">{{ $t("UzbXTV") }}</h5>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-7"></div>
                <div class="col-4 align-self-end">
                  <img
                    src="@/assets/images/profile-img.png"
                    alt
                    class="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link tag="a" to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo.svg" alt height="34" />
                  </span>
                </div>
              </router-link>
            </div>
            <b-alert
              v-model="isAuthError"
              variant="danger"
              class="mt-3"
              dismissible
              >{{ authError }}</b-alert
            >
            <div
              v-if="notification.message"
              :class="'alert ' + notification.type"
            >
              {{ notification.message }}
            </div>

            <b-form class="p-2">
              <b-form-group
                class="mb-3"
                id="input-group-1"
                :label="$t('Username')"
                label-for="input-1"
              >
                <b-form-input
                  v-if="!isLocal"
                  @keyup.enter="SignIn"
                  id="input-1"
                  v-model="login.username"
                  type="text"
                  :placeholder="$t('Username')"
                  :class="{ 'is-invalid': submitted && $v.username.$error }"
                ></b-form-input>
                <b-form-input
                  v-if="isLocal"
                  @keyup.enter="tryToLogIn"
                  id="input-1"
                  v-model="username"
                  type="text"
                  :placeholder="$t('Username')"
                  :class="{ 'is-invalid': submitted && $v.username.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.username.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.username.required">{{
                    $t("Username is required")
                  }}</span>
                </div>
              </b-form-group>

              <b-form-group
                class="mb-3"
                id="input-group-2"
                :label="$t('Password')"
                label-for="input-2"
              >
                <b-form-input
                  v-if="!isLocal"
                  @keyup.enter="SignIn"
                  id="input-2"
                  v-model="login.password"
                  type="password"
                  :placeholder="$t('Password')"
                  :class="{ 'is-invalid': submitted && $v.password.$error }"
                ></b-form-input>
                <b-form-input
                  v-if="isLocal"
                  @keyup.enter="tryToLogIn"
                  id="input-2"
                  v-model="password"
                  type="password"
                  :placeholder="$t('Password')"
                  :class="{ 'is-invalid': submitted && $v.password.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.password.required"
                  class="invalid-feedback"
                >
                  {{ $t("Password is required") }}
                </div>
              </b-form-group>

              <!-- CAPTCHA component -->
              <Captcha
                v-if="showCaptcha"
                @update-captcha-text="login.captchatext = $event"
                :result="result"
              />

              <div class="mt-3 d-grid">
                <b-button
                  v-if="isLocal"
                  @click="tryToLogIn"
                  :disabled="LoginLoading"
                  variant="primary"
                  class="btn-block"
                >
                  <b-spinner v-if="LoginLoading" small></b-spinner>
                  {{ $t("login") }}
                </b-button>
                <b-button
                  v-if="!isLocal"
                  @click="SignIn"
                  :disabled="LoginLoading"
                  variant="primary"
                  class="btn-block"
                >
                  <b-spinner v-if="LoginLoading" small></b-spinner>
                  {{ $t("login") }}
                </b-button>
              </div>
            </b-form>
          </div>
        </div>
        <b-modal
          v-model="sms.trusteddevice"
          hide-footer
          no-close-on-backdrop
          :title="$t('SmsCode')"
        >
          <b-alert show variant="success">
            <p class="p-1">
              {{ $t("SendSmmYourPhone", { phonenumber: sms.phoneNumber }) }}
            </p>
          </b-alert>
          <b-row>
            <b-col>
              <label for=""> {{ $t("SmsCode") }} </label>
              <b-form-input maxlength="4" v-model="sms.smscode"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col class="text-center">
              <b-button
                variant="danger"
                @click="sms.trusteddevice = false"
                class="mr-2"
              >
                <b-icon icon="x"></b-icon>{{ $t("Cancel") }}
              </b-button>
              <b-button variant="success" @click="SignTwoFactor">
                <b-spinner small v-if="SignTwoFactorLoading"></b-spinner>
                <b-icon
                  v-if="!SignTwoFactorLoading"
                  icon="check-square"
                ></b-icon>
                {{ $t("SignIn") }}
              </b-button>
            </b-col>
          </b-row>
        </b-modal>
        <div class="mt-5 text-center">
          <p>© {{ new Date().getFullYear() }} {{ $t("XTV") }}</p>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module></style>
